import { jsx } from 'react/jsx-runtime';
import 'date-fns-tz';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import './alert.js';
import '@radix-ui/react-avatar';
import './badge.js';
import 'lucide-react';
import 'react';
import 'react-day-picker';
import './button.js';
import './chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import { Input } from './input.js';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '@radix-ui/react-progress';
import './radio-group.js';
import '@radix-ui/react-select';
import './time-input.js';
import '@radix-ui/react-separator';
import './sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import '@clerk/clerk-react';
import '../../lib/toast.js';
import 'react-router-dom';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import '../page-layout/FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

/**
 * Time picker component using native HTML time input
 * @param time - Time value in HH:mm or HH:mm:ss format
 * @param onTimeChange - Callback when time changes
 * @param placeholder - Placeholder text (not visible in most browsers)
 * @param disabled - Whether the picker is disabled
 * @param className - Additional CSS classes
 * @param withSeconds - Whether to include seconds (default: false)
 */
function TimePicker({ time, onTimeChange, placeholder, disabled = false, className, withSeconds = false, }) {
    return (jsx(Input, { type: "time", step: withSeconds ? '1' : undefined, value: time, onChange: e => onTimeChange?.(e.target.value), placeholder: placeholder, disabled: disabled, className: cn('bg-background appearance-none [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none', className) }));
}

export { TimePicker };
//# sourceMappingURL=time-picker.js.map
